import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { juvareColors } from '@juvare/common-web-ui/JuvareTheme';
import { Alert, Box, Typography } from '@mui/material';
import React from 'react';
import promoteShiftsHeaderIllustration from '../assets/promoteShiftsHeaderIllustration.svg';
import { useMissionsTranslation } from '../hooks';
export const promoteShiftsDialog = (title, description, confirmButtonLabel, promoteShiftsDialogCallback, promotedAt) => showConfirmDialog({
    title: React.createElement(PromoteShiftsDialogHeader, { title: title }),
    content: React.createElement(PromoteShiftsDialogContent, { description: description, promotedAt: promotedAt }),
    confirmLabel: confirmButtonLabel,
    onConfirm: promoteShiftsDialogCallback,
});
const PromoteShiftsDialogHeader = ({ title }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { display: 'flex', flexDirection: 'column', gap: 2 },
        React.createElement("img", { style: { width: '100%' }, src: promoteShiftsHeaderIllustration, alt: t('shifts.promoteShiftsDialog.illustrationAlt') }),
        React.createElement(Typography, { variant: 'h6', sx: { color: (theme) => theme.palette.grey[900] } }, title)));
};
const PromoteShiftsDialogContent = ({ description, promotedAt }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { display: 'flex', flexDirection: 'column', gap: 2 },
        React.createElement(Typography, { variant: 'body1', sx: { color: (theme) => theme.palette.grey[700] } }, description),
        promotedAt && (React.createElement(Alert, { severity: 'info' },
            React.createElement(Typography, { variant: 'subtitle2', color: juvareColors.blue[900] }, `${t('shifts.promoteShiftsDialog.lastPromoted')} ${t('dateString', { value: promotedAt })} ${t('time', {
                value: promotedAt,
            })}`)))));
};
